<template>
  <vx-card id="printMe" v-if="generalInfo" no-shadow>
    <vs-row vs-justify="space-between" vs-w="12">
      <h2 class="mb-6">
        Answers
        <span class="muted-header">({{ questions.length }} questions)</span>
      </h2>
      <vs-button
        radius
        color="primary"
        type="border"
        size="small"
        icon="print"
        v-print="'#printMe'"
      ></vs-button>
    </vs-row>
    <!--<p>Visit by:: {{ moment(visit.created).format("DD/MM/yy") }}</p>-->
    <p>
      {{ typeDesc }} completed on:
      <strong>{{ moment(visit.completedOn).format("DD/MM/yy") }}</strong>
    </p>
    <p>
      Venue name: <strong>{{ generalInfo.displayName }}</strong>
    </p>
    <p>
      {{ typeDesc }} by:
      <strong
        >{{
          `${user(generalInfo.userId).firstName} ${
            user(generalInfo.userId).lastName
          }`
        }}
        ({{ user(generalInfo.userId).email }})</strong
      >
    </p>
    <ul v-if="questions.length > 0" class="list-unstyled components mb-5 mt-3">
      <li
        v-for="(question, index) in questions"
        :key="index"
        class="col-sm-5 mb-3 survey-card"
      >
        <h5>Question {{ index }}: {{ question.title }}</h5>
        <p>{{ question.helpText }}</p>
        <div v-if="question.questionType === 'MultipleChoice'">
          <div
            class="form-check"
            v-for="option in question.configMultipleChoice.options"
            :key="option.id"
          >
            <input
              type="radio"
              style="pointer-events: none"
              :name="option.id"
              :value="option.id"
              :checked="option.isSelected"
              class="form-check-input"
            />
            <label class="form-check-label">
              {{ option.text }}
            </label>
          </div>
        </div>
        <div v-if="question.questionType === 'TextInput'">
          <div>
            <vs-row class="mb-2 mt-2">
              <vs-col vs-w="4">
                <vs-textarea
                  :disabled="true"
                  ref="commentarea"
                  width="550px"
                  :value="question.configTextInput.userInput"
                  rows="1"
                  @focus="resize"
                  @keyup="resize"
                  :placeholder="question.configTextInput.placeholderText"
                />
              </vs-col>
            </vs-row>
          </div>
        </div>
        <div v-if="question.questionType === 'MediaUpload'">
          <div>
            <div class="row mb-3">
              <div class="col-sm-5">
                <span>{{
                  question.configMediaUpload.entries.length > 0
                    ? "Uploaded image(s)"
                    : "No image uploaded."
                }}</span>
                <img
                  v-for="(media, index) in question.configMediaUpload.entries"
                  :key="index"
                  :src="media.mediaUrl"
                  style="max-width: 300px; height: auto"
                />
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <!-- end -->
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  props: {
    type: "",
    visit: null,
    answers: [],
    questions: [],
  },
  computed: {
    ...mapGetters({
      user: "users/user",
      activeVenue: "venues/activeVenue",
    }),
    typeDesc() {
      return this.type === "maintenanceReview" ? "Review" : "Visit";
    },
  },
  data() {
    return { moment, generalInfo: null };
  },
  methods: {
    resize() {
      var inputs, index;

      inputs = document.getElementsByTagName("textarea");
      for (index = 0; index < inputs.length; ++index) {
        var ar = inputs[index];
        ar.style.height = ar.scrollHeight + 20 + "px";
      }
    },
  },
  async mounted() {
    this.surveySessionId = this.$route.params.surveySessionId;
    await this.$store.dispatch("venues/getVisits", this.activeVenue.venueId);
    await this.$store.dispatch(
      "venues/getMaintenanceReviews",
      this.activeVenue.venueId
    );
    const repo =
      this.type === "maintenanceReview"
        ? "venues/maintenanceReviews"
        : "venues/visits";
    this.generalInfo = this.$store.getters[repo](
      this.activeVenue.venueId
    ).filter((e) => e.surveySessionId === this.surveySessionId)[0];

    this.$nextTick(() => {
      this.resize();
    });
  },
};
</script>

<style style="scss" scoped>
.survey-card {
  background-color: #f5f7fb;
  border-radius: 10px;
  padding: 15px;
}
img {
  border-radius: 10px;
}
.muted-header {
  font-size: 14px;
  opacity: 0.5;
}
</style>